export const payRetailersConfig = {
  id: 'payretailers',
  assets: '/branding/payretailers/assets',
  name: 'Pay Retailers',
  showStatusMenu: false
};
